<div class="group relative">
  @if (label()) {
  <label
    [for]="inputId()"
    class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5 ml-1 transition-colors"
    [class.text-red-500]="control().invalid && (control().dirty || control().touched || submitted())"
  >
    {{ label() }}
  </label>
  }

  <ng-content></ng-content>

  <!-- Error messages (in flow so they are part of the component content) -->
  @if (control().invalid && (control().dirty || control().touched ||
  submitted())) { @if (getFirstErrorKey(); as errorKey) {
  <div class="mt-1.5 ml-1 text-sm text-red-600 dark:text-red-400 font-medium">
    {{ (errorMessages()[errorKey] || errorMessages()['default'] ||
    'FORM.FIELD_INVALID') | translate }}
  </div>
  } }
</div>
